// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__36YFv","actions":"GroupTable_actions__2C-LF","deleteModalFooter":"GroupTable_deleteModalFooter__2tZ0P"};